export enum RequestStatus {
  Default,
  Loading,
  Success,
  Error,
}
